(function() { window.GUID_feba2908_e2bd_4f18_b231_f6b22556bc89 = { getGuid: function() { return "feba2908-e2bd-4f18-b231-f6b22556bc89"; } }; })();
var CS;
(function (CS) {
    var Controls;
    (function (Controls) {
        class RatingComponent extends Controls.ControlBase {
            get ControlId() {
                return this.controlId;
            }
            get $Control() {
                return $(`#${this.ControlId}`);
            }
            constructor(props) {
                super(props.controlId);
                this.max = 5;
                this.defaultValue = 0;
                this.iconFillColor = "#FEC56F";
                this.filledIcon = "&#9733;";
                this.hollowIcon = "&#9734;";
                this.iconCssClass = "rating-component__icon";
                this.selectedIconCssClass = "rating-component__icon--selected";
                this.hoveredIconCssClass = "rating-component__icon--hovered";
                this.labelByValueMap = {};
                this.labelCssClass = "rating-component__label";
                this.iconsCssClass = "rating-component__icons";
                this.controlId = props.controlId;
                if (props.max) {
                    this.max = props.max;
                }
                if (props.defaultValue) {
                    this.defaultValue = props.defaultValue;
                }
                if (props.labelByValueMap) {
                    this.labelByValueMap = props.labelByValueMap;
                }
                if (props.$parentContainer) {
                    this.$parentContainer = props.$parentContainer;
                }
            }
            OnControlInstantiation(_) { }
            OnBindEvents() { }
            OnDispose() { }
            init() {
                try {
                    this.createHTML()
                        .then(() => {
                        this.bindEvents();
                    })
                        .catch((error) => {
                        throw new Error(error);
                    });
                }
                catch (error) {
                    console.error("Error while initializing control", error);
                }
            }
            createHTML() {
                return new Promise((resolve, reject) => {
                    try {
                        if (this.$Control.length === 0) {
                            if (!this.$parentContainer || this.$parentContainer.length === 0) {
                                return reject("Parent container not found");
                            }
                            $("body").append(`<div id="${this.ControlId}" class="rating-component"></div>`);
                        }
                        const iconsContainerHTML = `<div class="${this.iconsCssClass}"></div>`;
                        const $iconsContainer = $(iconsContainerHTML);
                        this.$Control.append($iconsContainer);
                        const iconStyle = `color: ${this.iconFillColor};`;
                        for (let i = 1; i <= this.max; i++) {
                            const isSelected = i <= this.defaultValue;
                            const cssClass = isSelected
                                ? `${this.iconCssClass} ${this.selectedIconCssClass}`
                                : this.iconCssClass;
                            const iconHTML = `<div class="${cssClass}" data-value="${i}" style="${iconStyle}" data-selected="${isSelected}"></div>`;
                            const $icon = $(iconHTML);
                            this.setIconContent($icon, isSelected);
                            $iconsContainer.append($icon);
                        }
                        this.setLabel(this.defaultValue);
                        return resolve();
                    }
                    catch (error) {
                        return reject(error);
                    }
                });
            }
            bindEvents() {
                this.$Control.on("mouseover.RatingComponentIcon", `.${this.iconCssClass}`, this.handleIconHoverStart.bind(this));
                this.$Control.on("mouseout.RatingComponent", `.${this.iconsCssClass}`, this.hanleHoverEnd.bind(this));
                this.$Control.on("click.RatingComponentIcon", `.${this.iconCssClass}`, this.handleClick.bind(this));
            }
            handleIconHoverStart(event) {
                try {
                    if (event.currentTarget === null) {
                        return;
                    }
                    const value = parseInt($(event.currentTarget).data("value"));
                    const $iconsBeforeOrEqual = this.$Control
                        .find(`.${this.iconCssClass}`)
                        .filter((_, icon) => {
                        return parseInt($(icon).data("value")) <= value;
                    });
                    if ($iconsBeforeOrEqual.length) {
                        $iconsBeforeOrEqual.addClass(this.hoveredIconCssClass);
                        this.setIconContent($iconsBeforeOrEqual, true);
                    }
                    const $iconsAfter = this.$Control
                        .find(`.${this.iconCssClass}`)
                        .filter((_, icon) => {
                        return parseInt($(icon).data("value")) > value;
                    });
                    if ($iconsAfter.length) {
                        $iconsAfter.removeClass(this.hoveredIconCssClass);
                        $iconsAfter.removeClass(this.selectedIconCssClass);
                        this.setIconContent($iconsAfter, false);
                    }
                }
                catch (error) {
                    console.error("Error while handling icon hover start", error);
                }
            }
            hanleHoverEnd() {
                try {
                    const $lastHoveredIcon = this.$Control
                        .find(`.${this.hoveredIconCssClass}`)
                        .last();
                    const value = parseInt($lastHoveredIcon.data("value"));
                    const $iconsBeforeOrEqual = this.$Control
                        .find(`.${this.iconCssClass}`)
                        .filter((_, icon) => {
                        return parseInt($(icon).data("value")) <= value;
                    });
                    if ($iconsBeforeOrEqual.length) {
                        $iconsBeforeOrEqual.each((_, icon) => {
                            const $icon = $(icon);
                            $icon.removeClass(this.hoveredIconCssClass);
                            const isSelected = $icon.data("selected");
                            if (isSelected) {
                                $icon.addClass(this.selectedIconCssClass);
                            }
                            else {
                                $icon.removeClass(this.selectedIconCssClass);
                            }
                            this.setIconContent($icon, isSelected);
                        });
                    }
                    const $iconsAfter = this.$Control
                        .find(`.${this.iconCssClass}`)
                        .filter((_, icon) => {
                        return parseInt($(icon).data("value")) > value;
                    });
                    if ($iconsAfter.length) {
                        $iconsAfter.each((_, icon) => {
                            const $icon = $(icon);
                            $icon.removeClass(this.hoveredIconCssClass);
                            const isSelected = $icon.data("selected");
                            if (isSelected) {
                                $icon.addClass(this.selectedIconCssClass);
                            }
                            else {
                                $icon.removeClass(this.selectedIconCssClass);
                            }
                            this.setIconContent($icon, isSelected);
                        });
                    }
                }
                catch (error) {
                    console.error("Error while handling hover end", error);
                }
            }
            setIconContent($icon, isSelected) {
                try {
                    const icon = isSelected ? this.filledIcon : this.hollowIcon;
                    $icon.html(icon);
                }
                catch (error) {
                    console.error("Error while setting icon content", error);
                }
            }
            handleClick(event) {
                try {
                    if (event.currentTarget === null) {
                        return;
                    }
                    const $clickedIcon = $(event.currentTarget);
                    const isSelected = $clickedIcon.data("selected");
                    let value = parseInt($clickedIcon.data("value"));
                    if (value === 1 && isSelected) {
                        const anySelectedAfter = this.$Control
                            .find(`.${this.iconCssClass}`)
                            .filter((_, icon) => {
                            const $icon = $(icon);
                            const value = parseInt($icon.data("value"));
                            return value > 1 && $icon.data("selected");
                        }).length;
                        if (!anySelectedAfter) {
                            value = 0;
                        }
                    }
                    this.setValue(value);
                }
                catch (error) {
                    console.error("Error while handling icon click", error);
                }
            }
            setValue(value, triggerEvent = true) {
                try {
                    const $icons = this.$Control.find(`.${this.iconCssClass}`);
                    $icons.each((_, icon) => {
                        const $icon = $(icon);
                        const iconValue = parseInt($icon.data("value"));
                        const isSelected = iconValue <= value;
                        $icon.data("selected", isSelected);
                        $icon.removeClass(this.hoveredIconCssClass);
                        if (isSelected) {
                            $icon.addClass(this.selectedIconCssClass);
                        }
                        else {
                            $icon.removeClass(this.selectedIconCssClass);
                        }
                        this.setIconContent($icon, isSelected);
                    });
                    this.setLabel(value);
                    if (triggerEvent) {
                        this.trigger(RatingComponent.EventNames.ValueChanged, {
                            jqueryEventObject: null,
                            data: {
                                newValue: value,
                            },
                        });
                    }
                }
                catch (error) {
                    console.error("Error while setting value", error);
                }
            }
            setLabel(value) {
                try {
                    const $labelContainer = this.$Control.find(`.${this.labelCssClass}`);
                    if (!this.labelByValueMap) {
                        if ($labelContainer.length) {
                            $labelContainer.remove();
                        }
                        return;
                    }
                    const label = this.labelByValueMap[value];
                    if (!label) {
                        if ($labelContainer.length) {
                            $labelContainer.remove();
                        }
                        return;
                    }
                    if ($labelContainer.length) {
                        $labelContainer.text(label);
                    }
                    else {
                        this.$Control.prepend(`<div class="${this.labelCssClass}">${label}</div>`);
                    }
                }
                catch (error) {
                    console.error("Error while updating label", error);
                }
            }
            trigger(name, data) {
                this.Trigger(name, data);
            }
        }
        Controls.RatingComponent = RatingComponent;
        (function (RatingComponent) {
            class Events {
                static ValueChanged(param) {
                    Controls.RegisterEvent(RatingComponent, EventNames.ValueChanged, param);
                }
            }
            RatingComponent.Events = Events;
            class EventNames {
            }
            EventNames.ValueChanged = "value-changed";
            RatingComponent.EventNames = EventNames;
        })(RatingComponent = Controls.RatingComponent || (Controls.RatingComponent = {}));
    })(Controls = CS.Controls || (CS.Controls = {}));
})(CS || (CS = {}));

//# sourceMappingURL=RatingComponent.js.map
